import { render } from "./posheduleEditForm.vue?vue&type=template&id=bf54f7e2&scoped=true"
import script from "./posheduleEditForm.vue?vue&type=script&lang=js"
export * from "./posheduleEditForm.vue?vue&type=script&lang=js"

import "./posheduleEditForm.vue?vue&type=style&index=0&id=bf54f7e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf54f7e2"]])

export default __exports__